import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modelpopupconfirmation',
  templateUrl: './modelpopupconfirmation.component.html',
  styleUrl: './modelpopupconfirmation.component.scss'
})
export class ModelpopupconfirmationComponent {

  @Input() show = false;
  @Input() showHeaderMessage:any;
  @Input() showModelContent:any;
  @Input() languageData:any;

  /**
   * Optional call-to-action rendered under the message as a link. Left unset by
   * every existing caller, so the popup keeps its message-and-Close shape.
   */
  @Input() actionLinkText:any;

  /** Optional second link under the first (e.g. "Proceed to temporary enrollment"). Unset by existing callers. */
  @Input() secondActionLinkText:any;

  /**
   * Optional buttons that replace the single Close button, e.g. Update Info | Go to Locker Room | Continue.
   * Each entry is { key, label }; the key is sent back through actionButtonClicked. Unset by existing callers.
   */
  @Input() actionButtons: { key: string; label: string }[] = [];

  @Output() closedModelpopup = new EventEmitter<boolean>();
  @Output() actionButtonClicked = new EventEmitter<string>();
  @Output() actionLinkClicked = new EventEmitter<void>();
  @Output() secondActionLinkClicked = new EventEmitter<void>();
  public lang: any = {};
  selectedLanguage: any;
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.lang = {};
    this.languageData =   this.languageData??[]
    this.selectedLanguage = sessionStorage.getItem("language")
    for (let token of this.languageData) {
      this.lang[token.key] = token[this.selectedLanguage];
    }

  }

  closeModelpopup(){
    this.show=false;
    this.closedModelpopup.emit(false);

  }

  onActionLinkClick(){
    this.show=false;
    this.actionLinkClicked.emit();
  }

  onActionButtonClick(key: string){
    this.show=false;
    this.actionButtonClicked.emit(key);
  }

  onSecondActionLinkClick(){
    this.show=false;
    this.secondActionLinkClicked.emit();
  }

}